/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AccountReadonlyAdditionalDetails_configuration = {
    readonly " $fragmentRefs": FragmentRefs<"Hideable_configuration">;
    readonly " $refType": "AccountReadonlyAdditionalDetails_configuration";
};
export type AccountReadonlyAdditionalDetails_configuration$data = AccountReadonlyAdditionalDetails_configuration;
export type AccountReadonlyAdditionalDetails_configuration$key = {
    readonly " $data"?: AccountReadonlyAdditionalDetails_configuration$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AccountReadonlyAdditionalDetails_configuration">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountReadonlyAdditionalDetails_configuration",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Hideable_configuration"
        }
    ],
    "type": "Configuration",
    "abstractKey": null
} as any;
(node as any).hash = '42588dbbef606d1c1b8342e4c1da9ebe';
export default node;
